import React from 'react'
import { connect } from 'react-redux';
import { Card, CardBody, CardText, CardTitle } from 'reactstrap';
import { enumHelper } from '../../utils';
import ENUMS from '../../enums';

const TicketMessages = ({ messages }) => {


  return (
    <article className='py-3'>

      <main className='panel panel-default'>

        <div
          className='panel-heading d-flex justify-content-between align-items-center pointer'>
          <div><i className='fal fa-envelope-square px-1' />{locales('titles.messagesTransferedInTicket')}</div>
        </div>

        <div className='panel-body'>
          {messages.length && messages.map(message => (
            <Card className='my-3' key={message.id}>
              <CardBody>
                <CardTitle className='border-bottom'>
                  <div className='d-flex justify-content-between align-items-center'>
                    <h4 className='text-dark font-weight-bold font-large'>
                      {`${message.createdFullName}  -  ${enumHelper.convertEnumValueToTitle(ENUMS.TICKET_TYPES.list, message.type)}`}
                    </h4>
                    <h4 className='text-dark font-weight-bold font-large'>{message.createdAt}</h4>

                  </div>
                </CardTitle>

                <CardText>
                  {message.content}
                </CardText>
              </CardBody>
            </Card>
          ))}


        </div>


      </main>
    </article>
  )
}

const mapStateToProps = (state) => {
  return {
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketMessages);